import React, { useCallback } from 'react';

import {
  QButton,
  QEmptyState,
  QEmptyStateButtonGroup,
  QEmptyStatePrimaryButton,
  QEmptyStateSecondaryButtonGroup,
} from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';

export type SupplierUpSellStarterViewProps = {
  contactEmail: string;
};

const SupplierUpSellStarterView: React.FC<SupplierUpSellStarterViewProps> = ({ contactEmail }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const showProductVideo = useCallback(() => {
    navigate('/product-video');
  }, [navigate]);
  const openContact = useCallback(() => {
    window.open(`mailto:${contactEmail}`);
  }, [contactEmail]);
  return (
    <>
      <div data-cy={'upsell'}>
        <QEmptyState title={t('upSellViews.starterView.title')} subtitle={t('upSellViews.starterView.subtitle')}>
          <QEmptyStateButtonGroup>
            <QEmptyStatePrimaryButton>
              <QButton onClick={openContact}>{t('upSellViews.starterView.buttons.contactSupport')}</QButton>
            </QEmptyStatePrimaryButton>
            <QEmptyStateSecondaryButtonGroup>
              <QButton onClick={showProductVideo} variant="outline">
                {t('upSellViews.starterView.buttons.watchVideo')}
              </QButton>
            </QEmptyStateSecondaryButtonGroup>
          </QEmptyStateButtonGroup>
        </QEmptyState>
      </div>
      <Outlet />
    </>
  );
};

export default SupplierUpSellStarterView;
